import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { useDispatch } from "react-redux";

import { setListContainerRef } from "../../../actions/index";
import useMidDropBoxV3 from './hooks/useMidDropBoxV3';

// Used for sortable list
function MidDropBoxV2({ active, accept, style, drop, containerRef = null, containerRefLvl = 0, maxSpeed = 10, scroll = true, thresholdTop = 40, thresholdBottom = 60 }) {
  const dispatch = useDispatch();
  const elementRef = useRef(null);
  let container = containerRef?.current;
  if (container) {
    if (containerRefLvl !== 0) {
      for (let i = 0; i < containerRefLvl; i++) {
        container = container.parentElement;
      }
    }
  }
  const scrollSpeedRef = container?.scrollSpeedRef;
  const animFrameRef = container?.animFrameRef;

  useEffect(() => {
    let container = containerRef?.current;
    if (container) {
      if (containerRefLvl !== 0) {
        for (let i = 0; i < containerRefLvl; i++) {
          container = container.parentElement;
        }
      }
    }
    if (container && !container.scrollSpeedRef) {
      container.scrollSpeedRef = { current: 0 };
      container.animFrameRef = { current: null };
      dispatch(setListContainerRef(container));
    }
  }, [containerRef, containerRefLvl, dispatch]);

  const scrollStep = () => {
    if (scroll) {
      if (container && scrollSpeedRef.current !== 0) {
        container.scrollTop += scrollSpeedRef.current;
        animFrameRef.current = requestAnimationFrame(scrollStep);
      } else {
        cancelAnimationFrame(animFrameRef.current);
        animFrameRef.current = null;
      }
    }
  };

  const [{ isOver }, refDrop] = useDrop({
    accept,
    drop,
    collect: (monitor) => ({
      isOver: monitor.isOver()
    }),
    hover: (item, monitor) => {
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;
      if (!container) return;
      const listRect = containerRef.current.getBoundingClientRect();
      const scrollTop = container.scrollTop;
      const listTop = listRect.top + scrollTop;
      const listBottom = window.innerHeight;

      if (clientOffset.y > listBottom - thresholdBottom) {
        if (scrollSpeedRef) {
          scrollSpeedRef.current = maxSpeed;
        }
        if (animFrameRef && !animFrameRef.current) {
          animFrameRef.current = requestAnimationFrame(scrollStep);
        }
      } else if (clientOffset.y < listTop + thresholdTop) {
        if (scrollSpeedRef) {
          scrollSpeedRef.current = -maxSpeed;
        }
        if (animFrameRef && !animFrameRef.current) {
          animFrameRef.current = requestAnimationFrame(scrollStep);
        }
      } else {
        if (scrollSpeedRef) {
          scrollSpeedRef.current = 0;
        }
        if (animFrameRef && animFrameRef.current) {
          cancelAnimationFrame(animFrameRef.current);
          animFrameRef.current = null;
        }
      }
    }
  })
  // const opacity = (isOver) ? 1 : 0;

  useEffect(() => {
    if (elementRef.current) {
      refDrop(elementRef.current);
    }
  }, [refDrop]);

  useMidDropBoxV3(active, isOver);

  return <div ref={elementRef} className={`mid-drop-box`} style={{...style}} />
  // return <div ref={elementRef} className={`mid-drop-box`} style={{...style, opacity}} />
}

MidDropBoxV2.propTypes = {
  active: PropTypes.any.isRequired,
  accept: PropTypes.any.isRequired,
  style: PropTypes.object,
  drop: PropTypes.func.isRequired
}

export default MidDropBoxV2;
